import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { obtenerNumeroMaterial, registraMaterialCat } from "../../../api/materialesCat";
import { toast } from "react-toastify";
import { listarDepartamentos, listarPorTipoDepartamento } from "../../../api/departamentos";
import queryString from "query-string";

const AltaMaterialesCat = ({history, setShow}) => {
  const [folio, setfolio] = useState("");
  const [nombreMaterial, setnombreMaterial] = useState("")
  const [departamento, setDepartamento] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const obtenerFolio = () => {
    try {
      obtenerNumeroMaterial()
        .then((response) => {
          const { data } = response;
          // console.log(data)
          const { noMat } = data;
          setfolio(noMat);
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const [listarDepartamento, setListDepartamento] = useState([]);

  const obtenerDepartamento = () => {
    try {
      listarPorTipoDepartamento("Produccion")
        .then((response) => {
          const { data } = response;

          if (!listarDepartamento && data) {
            setListDepartamento(formatModelDepartamento(data));
          } else {
            const datosDepartamento = formatModelDepartamento(data);
            setListDepartamento(datosDepartamento);
          }
        })
        .catch((e) => { });
    } catch (e) { }
  };

  useEffect(() => {
    obtenerFolio()
    obtenerDepartamento()
  }, [])


  const registrarMaterial = async () => {
    try {
      const dataTemp = {
        folio: folio,
        nombreMaterial: nombreMaterial,
        descripcion: descripcion,
        folioDepartamento: departamento,
        estado: "activo",
        leido: 0,
      };
      registraMaterialCat(dataTemp).then((response) => {
        const { data } = response;
        history({
          search: queryString.stringify(""),
        });
        toast.success(data.mensaje)
        setShow(false);
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <Form>
        <Row className="mb-2 mb-md-4 mb-lg-7">
          <Col
            xs={12}
            md={3}
            lg={3}
            className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
          >
            <Form.Label>Folio: <code>*</code></Form.Label>
          </Col>
          <Col xs={12} md={9} lg={9}>
            <Form.Control
              type="text"
              placeholder="Folio del material"
              value={folio}
              disabled
            />
          </Col>
        </Row>
        <Row className="mb-2 mb-md-4 mb-lg-7">
          <Col
            xs={12}
            md={3}
            lg={3}
            className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
          >
            <Form.Label>Nombre: <code>*</code></Form.Label>
          </Col>
          <Col xs={12} md={9} lg={9}>
            <Form.Control
              type="text"
              placeholder="Nombre del material"
              value={nombreMaterial}
              onChange={(e) => setnombreMaterial(e.target.value)}
            />
          </Col>
        </Row>
        <Row className="mb-2 mb-md-4 mb-lg-7">
          <Col
            xs={12}
            md={3}
            lg={3}
            className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
          >
            <Form.Label>Departamento: <code>*</code></Form.Label>
          </Col>
          <Col xs={12} md={9} lg={9}>
            <Form.Control as="select" value={departamento}
              onChange={(e) => setDepartamento(e.target.value)}>
              <option value="">Seleccionar departamento</option>
              {listarDepartamento.map((departamento) => (
                <option value={departamento.folio}>{departamento.nombre}</option>
              ))}
            </Form.Control>
          </Col>
        </Row>
        <Row className="mb-2 mb-md-4 mb-lg-7">
          <Col
            xs={12}
            md={3}
            lg={3}
            className="d-flex align-items-start justify-content-end justify-content-md-end justify-content-lg-end"
          >
            <Form.Label>Descripción:</Form.Label>
          </Col>
          <Col xs={12} md={9} lg={9}>
            <Form.Control
              as="textarea"
              placeholder="Descripción del material"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
            />
          </Col>
        </Row>
      </Form>
      <div className="d-flex justify-content-center">
        <Button variant="success" onClick={registrarMaterial}>
          <FontAwesomeIcon icon={faFloppyDisk} /> Registrar
        </Button>
      </div>
    </div>
  );
};

function formatModelDepartamento(data) {
  const dataTemp = [];
  data.forEach((data) => {
    dataTemp.push({
      folio: data.folio,
      nombre: data.nombre,
    });
  });
  return dataTemp;
}

export default AltaMaterialesCat;
